import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class HsnCodeService extends ConfigurationService {

    public modelPath = 'pharmacy/hsns';

    getDTColumns () {
        const self = this;
        return [{
            name: 'hsn_id',
            title: 'Hsn Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'hsn_id'
        }, {
            name: 'hsn_no',
            title: 'Hsn No',
            data: 'hsn_no'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-hsn-code')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.hsn_id}" id="checkbox_${full.hsn_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.hsn_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-hsn-code')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.hsn_id}" class="btn btn-secondary">
						<i class="icon-pencil" data-modelPk="${full.hsn_id}"></i>
					</a>`;
                }
                return '';
            }
        }];
    }
}
